export type IconProps = {
  style?: "filled" | "outline";
  className?: string;
  title?: string;
};

export default function IconXfinityPro({ className, title }: IconProps) {
  return (
    <svg
      width="160"
      height="48"
      viewBox="0 0 160 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={title}
      className={className}
    >
      <rect width="160" height="48" fill="url(#pattern0_311_136521)" />
      <g clipPath="url(#clip0_311_136521)">
        <path
          d="M143.613 8H16.3867C7.33659 8 0 15.3873 0 24.5C0 33.6127 7.33659 41 16.3867 41H143.613C152.663 41 160 33.6127 160 24.5C160 15.3873 152.663 8 143.613 8Z"
          fill="#7B30FF"
        />
        <path
          d="M17.8943 23.4044L22.2204 17.372H23.7935L18.6547 24.3548L24.0164 31.628H22.2729L17.8288 25.4108L13.3454 31.628H11.7329L17.0553 24.434L11.9033 17.372H13.6207L17.9074 23.4044H17.8943Z"
          fill="white"
        />
        <path
          d="M28.4868 17.372H36.3918V18.6392H29.824V24.0116H35.1595V25.2788H29.824V31.628H28.4868V17.372Z"
          fill="white"
        />
        <path d="M40.9275 17.372H42.304V31.628H40.9275V17.372Z" fill="white" />
        <path
          d="M49.5142 31.628H48.177V17.2664H48.4785L57.1569 28.262V17.372H58.5072V31.6412H58.1795L49.501 20.6192V31.6148L49.5142 31.628Z"
          fill="white"
        />
        <path d="M64.3801 17.372H65.7566V31.628H64.3801V17.372Z" fill="white" />
        <path
          d="M74.3825 18.6788H70.2793V17.372H79.8885V18.6788H75.759V31.628H74.3825V18.6788Z"
          fill="white"
        />
        <path
          d="M88.7899 25.1864L83.769 17.372H85.3291L89.4978 24.0116L93.6797 17.372H95.2004L90.1664 25.1864V31.6148H88.7899V25.1864Z"
          fill="white"
        />
        <path
          d="M106.894 17.372H111.115C112.636 17.372 113.829 17.7416 114.707 18.4808C115.572 19.22 116.018 20.2496 116.018 21.5696C116.018 22.8896 115.585 23.9192 114.707 24.6584C113.842 25.3976 112.636 25.7672 111.115 25.7672H108.257V31.6148H106.881V17.372H106.894ZM114.615 21.5828C114.615 20.6192 114.314 19.8932 113.698 19.4048C113.082 18.9032 112.19 18.6656 111.023 18.6656H108.27V24.5132H111.023C112.19 24.5132 113.095 24.2624 113.698 23.774C114.314 23.2724 114.615 22.5464 114.615 21.596V21.5828Z"
          fill="white"
        />
        <path
          d="M120.659 17.372H124.88C126.401 17.372 127.594 17.7416 128.472 18.4808C129.337 19.22 129.783 20.2496 129.783 21.5828C129.783 22.6124 129.508 23.4704 128.97 24.1436C128.433 24.8168 127.672 25.292 126.689 25.5428L130.425 31.6148H128.865L125.26 25.754C125.116 25.7672 124.959 25.7804 124.815 25.7804H122.022V31.628H120.646V17.372H120.659ZM128.38 21.5828C128.38 20.6192 128.079 19.8932 127.463 19.4048C126.846 18.9032 125.955 18.6656 124.788 18.6656H122.035V24.5132H124.788C125.955 24.5132 126.86 24.2624 127.463 23.774C128.079 23.2724 128.38 22.5464 128.38 21.596V21.5828Z"
          fill="white"
        />
        <path
          d="M134.227 24.5C134.227 23.0744 134.529 21.8072 135.132 20.6984C135.735 19.5896 136.561 18.7184 137.622 18.098C138.684 17.4644 139.89 17.1476 141.267 17.1476C142.643 17.1476 143.849 17.4644 144.898 18.098C145.947 18.7316 146.773 19.6028 147.376 20.6984C147.979 21.8072 148.28 23.0744 148.28 24.5C148.28 25.9256 147.979 27.1928 147.376 28.3016C146.773 29.4104 145.947 30.2816 144.898 30.902C143.849 31.5356 142.63 31.8524 141.267 31.8524C139.903 31.8524 138.684 31.5356 137.622 30.902C136.561 30.2684 135.735 29.3972 135.132 28.3016C134.529 27.1928 134.227 25.9256 134.227 24.5ZM136.338 21.3848C135.866 22.2956 135.617 23.3384 135.617 24.5C135.617 25.6616 135.853 26.7044 136.338 27.6152C136.823 28.526 137.478 29.2388 138.317 29.7536C139.156 30.2684 140.139 30.5324 141.241 30.5324C142.342 30.5324 143.325 30.2684 144.164 29.7536C145.003 29.2388 145.672 28.526 146.143 27.6152C146.615 26.7044 146.864 25.6616 146.864 24.5C146.864 23.3384 146.629 22.2956 146.143 21.3848C145.658 20.474 145.003 19.7612 144.164 19.2464C143.325 18.7316 142.342 18.4676 141.241 18.4676C140.139 18.4676 139.156 18.7316 138.317 19.2464C137.478 19.7612 136.81 20.474 136.338 21.3848Z"
          fill="white"
        />
      </g>
      <defs>
        <pattern
          id="pattern0_311_136521"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use transform="matrix(0.00194378 0 0 0.00647927 -0.104336 -0.166667)" />
        </pattern>
        <clipPath id="clip0_311_136521">
          <rect
            width="160"
            height="33"
            fill="white"
            transform="translate(0 8)"
          />
        </clipPath>
        <image
          id="image0_311_136521"
          width="625"
          height="209"
          preserveAspectRatio="none"
        />
      </defs>
    </svg>
  );
}
